import React from 'react'
import Service from '../Service'

const MobileDevelopment = () => {
    const title = 'Mobile App Development'
    const description = 'Bug Resistance creates high-performance native and cross-platform mobile applications for iOS and Android. Using React Native, Flutter, and native SDKs, we build apps that are fast, reliable, and provide seamless experiences across all devices and screen sizes.'
  return (
    <>
        <Service title={title} description={description} />
    </>
  )
}

export default MobileDevelopment
